export default __webpack_public_path__ + "static/media/More_button_1.38db835e.svg";